export const LIST_URL_MASTER = {
	spesialis: {
		list: "/spesialist/listspesialist",
		delete: "/spesialist/deletespesialist",
		add: "/spesialist/addspesialist",
		update: "/spesialist/updatespesialist",
	},

	lokasi: {
		list: "",
		delete: "",
		add: "",
		update: "",
	},

	rumah_sakit: {
		update: "/hospital/updatehospital",
	},

	bed: {
		list: "/bed/listbed",
		delete: "/bed/deletebed",
		list_kelas_kamar: "/bed/listkelaskamar_bed",
		list_sirs_online: "/bed/listkelaskamarsirsonline_bed",
		list_golongan_kelas: "/bed/listgolongankelasaplicares_bed",
		list_kamar: "/bed/listkamar_bed",
	},

	kas: {
		list: "/kas/kas/list",
		add: "/kas/kas/add",
		update: "/kas/kas/update",
		delete: "/kas/kas/delete",
	},

	text_display_kunjungan: {
		list: "/displaytext/listdisplaytext_kunjungan",
		add: "/displaytext/adddisplaytext_kunjungan",
		update: "/displaytext/updatedisplaytext_kunjungan",
		delete: "/displaytext/deletedisplaytext_kunjungan",
	},

	text_display_loket: {
		list: "/displaytext/listdisplaytext_loket",
		add: "/displaytext/adddisplaytext_loket",
		update: "/displaytext/updatedisplaytext_loket",
		delete: "/displaytext/deletedisplaytext_loket",
	},

	asuransi: {
		list: "/insurance/listinsurance",
		list_master: "/insurance/listinsurance_master",
		add: "/insurance/addinsurance",
		update: "/insurance/updateinsurance",
		delete: "/insurance/deleteinsurance",
		jenis_harga: "/wmsfarmasi/master/harga/list",
	},

	perusahaan: {
		list: "/company/listcompany",
		add: "/company/addcompany",
		update: "/company/updatecompany",
		delete: "/company/deletecompany",
	},

	tipe_registrasi: {
		list: "/registration/registrationtype/listregistrationtype",
		update: "/registration/registrationtype/updateregistrationtype",
		delete: "/registration/registrationtype/deleteregistrationtype",
	},

	kelas_kunjungan: {
		list: "/registration/kelaskunjungan/listkelaskunjungan",
		add: "/registration/kelaskunjungan/addkelaskunjungan",
		update: "/registration/kelaskunjungan/updatekelaskunjungan",
		delete: "/registration/kelaskunjungan/deletekelaskunjungan",
	},

	poliklinik: {
		list: "/policlinic/listpoliclinic",
		add: "/policlinic/addpoliclinic",
		update: "/policlinic/updatepoliclinic",
		delete: "/policlinic/deletepoliclinic",
	},

	poliklinik_spesialis: {
		list: "/policlinic/listpoliclinicspesialist",
		add: "/policlinic/addpoliclinicspesialist",
		update: "/policlinic/updatepoliclinicspesialist",
		delete: "/policlinic/deletepoliclinicspesialist",
	},

	layanan: {
		list: "/layanan/listlayanan",
		add: "/layanan/addlayanan",
		update: "/layanan/updatelayanan",
		delete: "/layanan/deletelayanan",
	},

	ruang_layanan: {
		list: "/layanan/listlayanan_ruang",
		add: "/layanan/addlayanan_ruang",
		update: "/layanan/updatelayanan_ruang",
		delete: "/layanan/deletelayanan_ruang",

		layanan: "/layanan/listlayanan_msrl",
	},

	jenis_layanan: {
		list: "/jenis_layanan/listjenis_layanan",
		add: "/jenis_layanan/addjenis_layanan",
		update: "/jenis_layanan/updatejenis_layanan",
		delete: "/jenis_layanan/deletejenis_layanan",
	},

	jenis_rawat: {
		list: "/typeofcare/listtypeofcare",
		update: "/typeofcare/updatetypeofcare",
		add: "/typeofcare/addtypeofcare",
		delete: "/typeofcare/deletetypeofcare",
	},

	dokter: {
		list: "/doctor/listdoctor",
		export: "/doctor/listdoctor-export",
		update: "/doctor/updatedoctor",
		add: "/doctor/adddoctor",
		delete: "/doctor/deletedoctor",

		by_id: "/doctor/doctor_small_by_id",
		ktp_by_id: "/doctor/foto-by-id",
		ttd_by_id: "/doctor/ktp-by-id",

		spesialis: "/spesialist/listspesialist_doctor",
		agama: "/agama/listagama_doctor",
		kualifikasi: "/qualification/listqualification_doctor",
		bank: "/bank/listbank_doctor",
		poliklinik: "/policlinic/listpoliclinic_doctor",
		rumah_sakit: "/hospital/listhospital_sdoc",
	},

	jadwal_dokter: {
		list: "/doctor/listscheduledoctor_filter",
		update: "/doctor/updatescheduledoctor",
		add: "/doctor/addscheduledoctor",
		delete: "/doctor/deletescheduledoctor",

		rumah_sakit: "/hospital/listhospital_sdoc",
		layanan: "/layanan/listlayanan_sdoc",
		poliklinik: "/policlinic/listpoliclinic_sdoc",
		dokter: "/doctor/listdoctor_small",
	},

	kuota_online: {
		list: "/kas/kas/list",
		add: "/doctor/addquota_mobile",
		update: "/kas/kas/update",
		delete: "/kas/kas/delete",

		ubah_status: "/doctor/updatestatusquota_mobile",
		ubah_kuota: "/doctor/updatequota_mobile",
		dokter: "/doctor/listdoctor_kob",
	},

	tipe_antrian: {
		list: "/antrian/listantriantype",
		update: "/antrian/updateantriantype",
		add: "/antrian/addantriantype",
		delete: "/antrian/deleteantriantype",

		display_jenis_id: "/ant_display/listant_display_jenisid",
	},

	loket: {
		list: "/antrian/listloket",
		add: "/antrian/addloket",
		update: "/antrian/updateloket",
		delete: "/antrian/deleteloket",
	},

	movie_list: {
		list: "/movie/listmovie",
		add: "/movie/addmovie",
		update: "/movie/updatemovie",
		delete: "/movie/deletemovie",
	},

	movie_profiling: {
		list: "/movie/listmoviedisplay",
		add: "/movie/addmoviedisplay",
		update: "/movie/updatemoviedisplay",
		delete: "/movie/deletemoviedisplay",

		list_movie: "/movie/listmovie",
		add_list_movie: "/movie/addmovielist",
		list_movie_by_display: "/movie/listmovielistindisplay",
		delete_list_movie: "/movie/deletemovielist",
	},

	agama: {
		list: "/agama/listagama",
		add: "/agama/addagama",
		update: "/agama/updateagama",
		delete: "/agama/deleteagama",
	},

	kualifikasi: {
		list: "/qualification/listqualification",
		add: "/qualification/addqualification",
		update: "/qualification/updatequalification",
		delete: "/qualification/deletequalification",
	},

	bank: {
		list: "/bank/listbank",
		add: "/bank/addbank",
		update: "/bank/updatebank",
		delete: "/bank/deletebank",
	},

	golongan_darah: {
		list: "/atribut/atr_ms_bloodtype/listatr_ms_bloodtype",
		add: "/atribut/atr_ms_bloodtype/addatr_ms_bloodtype",
		update: "/atribut/atr_ms_bloodtype/updateatr_ms_bloodtype",
		delete: "/atribut/atr_ms_bloodtype/deleteatr_ms_bloodtype",
	},

	pendidikan: {
		list: "/atribut/atr_ms_education/listatr_ms_education",
		add: "/atribut/atr_ms_education/addatr_ms_education",
		update: "/atribut/atr_ms_education/updateatr_ms_education",
		delete: "/atribut/atr_ms_education/deleteatr_ms_education",
	},

	suku_bangsa: {
		list: "/atribut/atr_ms_ethnic/listatr_ms_ethnic",
		add: "/atribut/atr_ms_ethnic/addatr_ms_ethnic",
		update: "/atribut/atr_ms_ethnic/updateatr_ms_ethnic",
		delete: "/atribut/atr_ms_ethnic/deleteatr_ms_ethnic",
	},

	penanggung_jawab: {
		list: "/atribut/atr_ms_guarantor_connection/listatr_ms_guarantor_connection",
		add: "/atribut/atr_ms_guarantor_connection/addatr_ms_guarantor_connection",
		update:
			"/atribut/atr_ms_guarantor_connection/updateatr_ms_guarantor_connection",
		delete:
			"/atribut/atr_ms_guarantor_connection/deleteatr_ms_guarantor_connection",
	},

	pekerjaan: {
		list: "/atribut/atr_ms_jobs/listatr_ms_jobs",
		add: "/atribut/atr_ms_jobs/addatr_ms_jobs",
		update: "/atribut/atr_ms_jobs/updateatr_ms_jobs",
		delete: "/atribut/atr_ms_jobs/deleteatr_ms_jobs",
	},

	ruang_aplicares: {
		list: "/bed/list-ruang-aplicares",
		add: "/bed/add-ruang-aplicares",
		update: "/bed/update-ruang-aplicares",
		delete: "/bed/delete-ruang-aplicares",
	},

	golkelas_aplicares: {
		list: "/bed/listgolongankelasaplicares",
		delete: "/bed/deletegolongankelasaplicares",
		update: "/bed/updategolongankelasaplicares",

		list_ketersediaan_aplicare: "/bed/list-ruang-by-kelas",
		update_ketersediaan_aplicare: "/bed/update-ketersediaan-aplicares",
	},

	ruang_rs_online: {
		list: "/bed/list-ruang-sirsonline",
		add: "/bed/add-ruang-sirsonline",
		delete: "/bed/delete-ruang-sirsonline",
		update: "/bed/update-ruang-sirsonline",
		list_ruang_by_kelas_rsonline: "/bed/list-ruang-by-kelas-rsonline",
		list_ruang_by_kelas_rsonline_mobile: "/bed/list-ruang-by-kelas-rsonline-mobile",
	},

	kelas_rs_online: {
		list: "/bed/list-kelas-kamar-sirsonline",
		list_referensi_kelas: "/bed/list-referensi-kelas-kamar-sirsonline",
		update_ketersediaan_sirsonline: "bed/update-ketersediaan-sirsonline",

		add_kelas_kamar_sirsonline: "/bed/add-kelas-kamar-sirsonline",
		update_kelas_kamar_sirsonline: "/bed/update-kelas-kamar-sirsonline",
		delete_kelas_kamar: "/bed/delete-kelas-kamar-sirsonline",
		list_all_kelas_kamar_sirsonline: "/bed/list-all-ruang-sirsonline-api"
	},
};
